export default class InfrastructureError extends Error {
  type = 'infrastructure'
}
